const footer_es={
	    "rights":"LEVTY. Todos los derechos reservados.",
	    "visit":[
	        {
	            "title":"Acceso",
	            "plans":"Planes"
	        },
	        {
	            "title":"Redes sociales",
	            "description":"Siga a LEVTY en las redes sociales"
	        }
	    ],
        "privacyPolicy":"Política de privacidad"
};  
export default footer_es;